<app-header></app-header>
<div class="view">
    <div class="screens">
        <div class="screen">
            <app-zoomable-view class="primary">
                <router-outlet></router-outlet>
            </app-zoomable-view>
            <app-tool-layer></app-tool-layer>
        </div>
        @if (presentationMode) {
        <div class="screen second-screen">
            <app-second-screen></app-second-screen>
        </div>
        }
    </div>
    <app-tool></app-tool>
</div>

<app-tools></app-tools>

@if (presentationMode) {
<app-second-screen-slides></app-second-screen-slides>
} @if (presentationMode) {
<app-second-screen-print></app-second-screen-print>
}
